module.exports = __webpack_public_path__ + "static/media/logo.bac14d65.png";